import React, { PropsWithChildren } from 'react'
import { Box, BoxProps } from '@node-space/ui-components'

export interface FullScreenProps extends PropsWithChildren, BoxProps {}

export const FullScreenLayout = ({ children, ...rest }: FullScreenProps) => {
  return (
    <Box flex centerChildren width="full" minHeight="screen" {...rest}>
      {children}
    </Box>
  )
}
